<div class="column">
    <h2>Malattia di Crohn - Pazienti stabili e instabili per malattia attiva/inattiva iniziale</h2>
    <h3>L'analisi è stata effettuata considerando i pazienti che hanno compilato il questionario HBI.</h3>
    <h3>Cut-off: 5.</h3>
    <div style="display: inline-block" style = "padding-left: 3vw; padding-top: 0vw; position: center">
      <div class = "chart-container" [ngStyle]="{'cursor': isHovered ? 'pointer' : ''}">
        <canvas id = "myChartStableUnstableCrohnInitialActiveInactivePathology"></canvas>
      </div>
    </div>
  </div>